<template>
  <div class="table" ref="tableRef">
    <artmisads-table
      :columns="columns"
      row-key="id"
      :data-source="props.dataList"
      :pagination="{
        total: props.listTotal,
        current: props.params.page,
        pageSize: props.params.size,
        showSizeChanger: true
      }"
      :change="onChangePage"
      tableLayout="fixed"
      :scroll="{ x: 1600 }"
    >
      <template #bodyCell="{ column, record, text }">
        <template v-if="column.name === 'showCurrency'">
          {{AMAZON_CURRENCY_MAPPER[record.marketplace]}}{{text}}
        </template>
        <template v-if="column.name === 'marketplace'">
          <div class="table-marketplace">
           <div>
              <Icon :name="COUNTRY_BASE_MAP[text].icon"></Icon>
              <span>{{text}}</span>
           </div>
          </div>
        </template>
        <template v-if="column.name === 'billingType'">
          <div class="billing-type">
            {{ setBillingType(record.billingType) }}
          <a-tooltip placement="top" v-if="record.billingType !== 'MONTHLY'">
            <template #title>
              <span>{{record.billingType === 'MANUAL'? 'Manually generated billing data, may include various adjustments' : 'Adjustment reflecting conclusive return verification for the transaction cycle.'}}</span>
           </template>
           <Icon
                  name="wenhao-tianchong"
                  class="question-icon"
                /> 
          </a-tooltip>
          </div>
          
        </template>
        <template v-if="column.name === 'amount'&&record.billingType !== 'MONTHLY'">
                  <div :class="text? text > 0 ? 'amount-plus' : 'amount-minus':''">
                    {{ setUnit(text) }} {{text||text==0? AMAZON_CURRENCY_MAPPER[record.marketplace] :''}}{{ setAmount(text) }}
                  </div>
                 
         </template>
         <template v-if="column.name === 'amount'&&record.billingType === 'MONTHLY'">
          {{text||text==0? AMAZON_CURRENCY_MAPPER[record.marketplace] :'--'}}{{ text }}
         </template>
        <template v-if="column.name === 'transactionCycleStartDate'">
          {{record.transactionCycleStartDate}} - {{record.transactionCycleEndDate}}
        </template>
        <template v-if="column.name === 'status'">
          <div v-if="record.billingType === 'MONTHLY'">
            <div v-if="record['displayStatus'] === 'Paid'||record['displayStatus']==='Not Paid'||record['displayStatus']===''">
            <financeStatus :type="record['status']"/>
          </div>
          <div v-else>
            <financeStatus  :pageType="record['displayStatus']" :pageTypeClass="record['status']"/>
          </div>
          </div>
          <div v-else>
            <financeStatus  :pageType="record['displayStatus']" :pageTypeClass="record['status']"/>
          </div>
         
        </template>
        
        <template v-if="column.name === 'billingDateTimestamp'">
          {{moment(record.billingDateTimestamp).format('YYYY-MM')}}
        </template>
        <template v-if="column.name === 'actions'">
          <div class="actions">
            <artmisads-select-button @click="() => props.setDetailData(record, 'detail')" size="small">Details</artmisads-select-button>
          </div>
        </template>
      </template>
    </artmisads-table>
  </div>
</template>
<script lang="jsx" setup>
  import moment from 'moment';
  import { ref } from 'vue';
  import { keyBy } from 'lodash';
  import Icon from '~/components/Icon.vue';
  import financeStatus from '~/components/financeStatus';
  import { COUNTRY_BASE } from "~/contants/common";
  import { AMAZON_CURRENCY_MAPPER } from '~/contants/common';
  import { useTableScrollHeight } from "@/utils/useTableScrollHeight";
  const COUNTRY_BASE_MAP = keyBy(COUNTRY_BASE, 'host');

  const tableRef = ref(null);
  const props = defineProps([ 'listTotal', 'setParams', 'params', 'dataList', 'getList', 'setSpinning', 'setDetailData']);
  const columns = [
    {
      title: 'Date',
      dataIndex: 'billingDateTimestamp',
      width: 80,
      name: 'billingDateTimestamp',
    },
    {
      title: 'Payment ID',
      dataIndex: 'billingId',
      width: 180,
    },
    {
    width: 120,
    title:'Type',
    dataIndex: 'billingType',
    name: 'billingType',
  },
    {
      title: 'Transaction Cycle',
      dataIndex: 'transactionCycleStartDate',
      width: 150,
      name: 'transactionCycleStartDate'
    },
    // {
    //   title: 'Marketplace',
    //   dataIndex: 'marketplace',
    //   width: 130,
    //   name: 'marketplace'
    // },
    {
      title: 'Amount',
      dataIndex: 'amount',
      width: 110,
      name: 'amount',
    },
    {
       title: 'Awaiting Brand Payment',
      dataIndex: 'pendingAmount',
      width: 110,
      name: 'amount',
    },
    {
       title: 'Scheduled Payment',
      dataIndex: 'readyToPayAmount',
      width: 110,
      name: 'amount',
    },
    {
      title: 'ArtemisAds Paid Amount',
      dataIndex: 'paidAmount',
      width: 110,
      name: 'amount',
    },
    {
      title: 'payment Status',
      dataIndex: 'status',
      name: 'status',
      width: 120,
    },
    {
      title: 'Action',
      dataIndex: 'id',
      name: 'actions',
      width: 80,
    },
  ]
  const setBillingType = (value) => {
  if (value === undefined || value === null) return '';
  const str = String(value).toLowerCase();
  return str.charAt(0).toUpperCase() + str.slice(1);
};
const setUnit = (record) => {
  if(record||record==0){
    if (record > 0) {
    return '+'
  }
  else if(record == 0){
    return ''
  }
  else {
    return '-'
  }
  }
  else{
    return ''
  }
}
const setAmount = (record) => {
  if(record||record==0){
  return Math.abs(record)
  }
  else{
    return '--'
  }
}
  const onChangePage = (data) => {
    const { current, pageSize } = data;
    console.log('data',data)
    let newParams = { ...props.params };
    newParams.page = current;
    newParams.size = pageSize;
    // props.setParams(newParams);
    props.getList(newParams);
  }
  const { tableScrollHeight } = useTableScrollHeight({
  selector: '.table',
  bottomSpace: 260,
  minHeight: 200,
  maxHeight:1000,
  defaultHeight: 350
});
</script>
<style lang="less" scoped>
.amount-plus{
  color: #FF0000;
}
.amount-minus{
  color: #2AAE67;
}
  .table {
    padding: 16px 0;
    :deep(.ant-tooltip-arrow) {
      display: none;
    }
    :deep(.ant-table) {
      .table-marketplace {
        display: inline-block;
        > div {
          display: flex;
          background-color: var(--bg-gray-8);
          border-radius: 4px;
          padding: 0 6px;
          line-height: 20px;
          > svg {
            width: 20px;
            height: 20px;
            margin-right: 4px;
            align-self: center;
          }
        }
        
      }
      .ant-table-thead {
        .ant-table-cell {
          line-height: 24px;
        }
      }
      .actions {
        display: flex;
        button {
          align-self: center;
          margin-right: 8px;
        }
      }
    }
  }
</style>